import { Button } from '@shared/components/ui/button';
import { usePermissions } from '@shared/hooks/usePermissions';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface CreatePackButtonProps {
  /** Función callback para crear pack */
  onCreatePack: () => void;
}

/**
 * Componente para el botón de crear pack
 * Maneja la navegación y permisos de creación
 */
export const CreatePackButton: React.FC<CreatePackButtonProps> = ({ onCreatePack }) => {
  const { t } = useTranslation('packsModule');
  const { canAccess } = usePermissions();

  // Verificar si el usuario puede crear packs
  const canCreate = canAccess(['tenant', 'tenant_3pl', 'tenant_external'], ['packs.create']);

  const handleCreatePack = useCallback(() => {
    onCreatePack();
  }, [onCreatePack]);

  // Si no tiene permisos, no mostrar el botón
  if (!canCreate) {
    return null;
  }

  return (
    <Button variant="primary" size="lg" onClick={handleCreatePack} data-testid="create-pack-button">
      {t('actions.create_pack')}
    </Button>
  );
};
